import { render, staticRenderFns } from "./updates.vue?vue&type=template&id=2e29758c&scoped=true&"
import script from "./updates.vue?vue&type=script&lang=js&"
export * from "./updates.vue?vue&type=script&lang=js&"
import style0 from "./updates.vue?vue&type=style&index=0&id=2e29758c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29758c",
  null
  
)

export default component.exports